import React, { useMemo } from 'react';
import { MUITable } from 'components/shared/MUITable';
import { createSubmissionDocumentsColumns } from '../../lib';
import { CreditSubmissionDocumentRow } from '../../types';

interface Props {
  documents: CreditSubmissionDocumentRow[];
  isLoading: boolean;
  onToggleLenderAccess: (documentId: string) => void;
}

export const SubmissionDocumentsTable = ({ documents, isLoading, onToggleLenderAccess }: Props) => {
  const columns = useMemo(() => createSubmissionDocumentsColumns(onToggleLenderAccess), [onToggleLenderAccess]);

  return <MUITable<CreditSubmissionDocumentRow> columns={columns} isLoading={isLoading} tableData={documents} />;
};
